import React, { useState, useEffect, useRef } from 'react';
import { Container } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImages, faCamera } from '@fortawesome/free-solid-svg-icons';
import footerBg from "../../assets/footerbg.jpg";
// import media1 from '../../assets/media/media1.jpeg'
import media2 from '../../assets/media/media2.jpeg'
import media3 from '../../assets/media/media3.jpeg'
import media4 from '../../assets/media/media4.jpeg'
import media5 from '../../assets/media/media5.jpeg'
import media6 from '../../assets/media/media6.jpeg'
import media7 from '../../assets/media/media7.jpeg'
import media8 from '../../assets/media/media8.jpeg'
import media9 from '../../assets/media/media9.jpeg'
import media10 from '../../assets/media/media10.jpeg'
import media11 from '../../assets/media/media11.jpeg'
import media12 from '../../assets/media/media12.jpeg'
import media13 from '../../assets/media/media13.jpeg'
import flag1 from '../../assets/media/flag1.jpg'
import flag2 from '../../assets/media/flag2.jpg'
import flag3 from '../../assets/media/flag3.jpg'

import flag4 from '../../assets/media/flag4.jpg'
import flag5 from '../../assets/media/flag5.jpg'
import flag6 from '../../assets/media/flag6.jpg'
import flag7 from '../../assets/media/flag7.jpg'
import flag8 from '../../assets/media/flag8.jpg'
import acs1 from '../../assets/media/acs1.jpg'
import acs2 from '../../assets/media/acs2.jpg'

// FadeUp Component for scroll animations
const FadeUp = ({ children, delay = 0 }) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(ref.current);
        }
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  return (
    <div
      ref={ref}
      style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(40px)',
        transition: `opacity 0.6s ease ${delay}s, transform 0.6s ease ${delay}s`,
      }}
    >
      {children}
    </div>
  );
};

const Media = () => {
   const items1=[media2,media3,media9,media10,media11,media12,media13];
   const items2=[media4,media5,media6,media7,media8];
   const items3=[flag1,flag2,flag3];
   const items4=[flag4,flag5,flag6,flag7,flag8];
   const items5=[acs1,acs2];
    return (

      <>
        {/* Header Section - Matching WhoWho Theme */}
        <div style={{
          backgroundImage: `url(${footerBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          padding: '30px 0',
          color: 'white',
          margin:'2%',
          borderRadius:'10px'
        }}>
          <Container>
            <h3 className="fw-bold mb-0 text-center">
              <FontAwesomeIcon icon={faImages} className="me-2" />
              Media Gallery
            </h3>
          </Container>
        </div>

 <div className="container-fluid px-5 mb-3" >
<h4 style={{  
          color:'#1e3c72',
          fontWeight: '600',
          marginBottom: '20px',
          padding: '10px 0',
          // borderBottom: '3px solid #1e3c72',
          display: 'inline-block',
          textAlign:'center',
          textDecoration:'underline'
        }}>
          <FontAwesomeIcon icon={faCamera} className="me-2" style={{color: '#16a085'}} />
         Flag Day Contribution by Hon'ble Chief Minister Shri Nayab Singh Saini and Fecilitation by Worthy ACS Vijayendra Kumar & Deputy Director Maj Neeraj Sharma
        </h4>
  
          <section className="content py-1 mb-3">
<div className="row justify-content-center">
          {items4.length > 0 &&
            items4.map((img, idx) => (
              <div className="col-lg-4 col-md-6 my-4" key={idx}>
                <FadeUp delay={idx * 0.1}>
                <div
                  className="media-card mx-2 h-100"
                  style={{
                    borderRadius: "12px",
                    overflow: 'hidden',
                    background: 'white',
                    transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                    cursor: 'pointer',
                    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-12px) scale(1.02)';
                    e.currentTarget.style.boxShadow = '0 20px 40px rgba(30, 60, 114, 0.25)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0) scale(1)';
                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.1)';
                  }}
                >
                  <div style={{
                    position: 'relative',
                    overflow: 'hidden',
                    borderRadius: "12px"
                  }}>
                    <img
                      src={img}
                      alt="Flag Day Media"
                      className="school-image"
                      width="100%"
                      height="280px"
                      style={{ 
                        borderRadius: "12px",
                        objectFit: "cover",
                        transition: 'transform 0.5s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'scale(1.1)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'scale(1)';
                      }}
                    />
                    <div style={{
                      position: 'absolute',
                      bottom: 0,
                      left: 0,
                      right: 0,
                      background: 'linear-gradient(to top, rgba(30, 60, 114, 0.9), transparent)',
                      padding: '20px 15px 15px',
                      color: 'white',
                      fontSize: '0.9rem',
                      fontWeight: '500'
                    }}>
                      <FontAwesomeIcon icon={faCamera} className="me-2" />
                      Media Photo {idx + 1}
                    </div>
                  </div>
                </div>
                </FadeUp>
              </div>
            ))}
        </div>
      
      </section>

<h4 style={{  
          color:'#1e3c72',
          fontWeight: '600',
          marginBottom: '20px',
          padding: '10px 0',
          // borderBottom: '3px solid #1e3c72',
          display: 'inline-block',
          textAlign:'center',
          textDecoration:'underline'
        }}>
          <FontAwesomeIcon icon={faCamera} className="me-2" style={{color: '#16a085'}} />
         Flag Day Contribution by His Excellency the Governor of Haryana Prof. Ashim Kumar Ghosh and fecilitation by Worthy ACS Vijayendra Kumar & Deputy Director Maj Neeraj Sharma
        </h4>
  
          <section className="content py-1 mb-3">
<div className="row justify-content-center">
          {items3.length > 0 &&
            items3.map((img, idx) => (
              <div className="col-lg-4 col-md-6 my-4" key={idx}>
                <FadeUp delay={idx * 0.1}>
                <div
                  className="media-card mx-2 h-100"
                  style={{
                    borderRadius: "12px",
                    overflow: 'hidden',
                    background: 'white',
                    transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                    cursor: 'pointer',
                    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-12px) scale(1.02)';
                    e.currentTarget.style.boxShadow = '0 20px 40px rgba(30, 60, 114, 0.25)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0) scale(1)';
                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.1)';
                  }}
                >
                  <div style={{
                    position: 'relative',
                    overflow: 'hidden',
                    borderRadius: "12px"
                  }}>
                    <img
                      src={img}
                      alt="Flag Day Media"
                      className="school-image"
                      width="100%"
                      height="280px"
                      style={{ 
                        borderRadius: "12px",
                        objectFit: "cover",
                        transition: 'transform 0.5s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'scale(1.1)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'scale(1)';
                      }}
                    />
                    <div style={{
                      position: 'absolute',
                      bottom: 0,
                      left: 0,
                      right: 0,
                      background: 'linear-gradient(to top, rgba(30, 60, 114, 0.9), transparent)',
                      padding: '20px 15px 15px',
                      color: 'white',
                      fontSize: '0.9rem',
                      fontWeight: '500'
                    }}>
                      <FontAwesomeIcon icon={faCamera} className="me-2" />
                      Media Photo {idx + 1}
                    </div>
                  </div>
                </div>
                </FadeUp>
              </div>
            ))}
        </div>
      
      </section>

      <h4 style={{  
          color:'#1e3c72',
          fontWeight: '600',
          marginBottom: '20px',
          padding: '10px 0',
          // borderBottom: '3px solid #1e3c72',
          display: 'inline-block',
          textAlign:'center',
          textDecoration:'underline'
        }}>
          <FontAwesomeIcon icon={faCamera} className="me-2" style={{color: '#16a085'}} />
         Worthy ACS Vijayendra Kumar welcomimg Maj Gen Prince Duggal, GOC, PH & HP (I) Sub Area, Ambala Cantt.
        </h4>
  
          <section className="content py-1 mb-3">
<div className="row justify-content-center">
          {items5.length > 0 &&
            items5.map((img, idx) => (
              <div className="col-lg-4 col-md-6 my-4" key={idx}>
                <FadeUp delay={idx * 0.1}>
                <div
                  className="media-card mx-2 h-100"
                  style={{
                    borderRadius: "12px",
                    overflow: 'hidden',
                    background: 'white',
                    transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                    cursor: 'pointer',
                    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-12px) scale(1.02)';
                    e.currentTarget.style.boxShadow = '0 20px 40px rgba(30, 60, 114, 0.25)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0) scale(1)';
                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.1)';
                  }}
                >
                  <div style={{
                    position: 'relative',
                    overflow: 'hidden',
                    borderRadius: "12px"
                  }}>
                    <img
                      src={img}
                      alt="Flag Day Media"
                      className="school-image"
                      width="100%"
                      height="280px"
                      style={{ 
                        borderRadius: "12px",
                        objectFit: "cover",
                        transition: 'transform 0.5s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'scale(1.1)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'scale(1)';
                      }}
                    />
                    <div style={{
                      position: 'absolute',
                      bottom: 0,
                      left: 0,
                      right: 0,
                      background: 'linear-gradient(to top, rgba(30, 60, 114, 0.9), transparent)',
                      padding: '20px 15px 15px',
                      color: 'white',
                      fontSize: '0.9rem',
                      fontWeight: '500'
                    }}>
                      <FontAwesomeIcon icon={faCamera} className="me-2" />
                      Media Photo {idx + 1}
                    </div>
                  </div>
                </div>
                </FadeUp>
              </div>
            ))}
        </div>
      
      </section>

        {/* <div className="container-fluid px-5 mb-3" > */}
<h4 style={{  
          color:'#1e3c72',
          fontWeight: '600',
          marginBottom: '20px',
          padding: '10px 0',
          // borderBottom: '3px solid #1e3c72',
          display: 'block',
          textAlign:'center',
          textDecoration:'underline'
        }}>
          <FontAwesomeIcon icon={faCamera} className="me-2" style={{color: '#16a085'}} />
          Flag Day Contribution by Hon'ble CM Shri Nayab Singh Saini
        </h4>
  
          <section className="content py-1 mb-3">
<div className="row justify-content-center">
          {items1.length > 0 &&
            items1.map((img, idx) => (
              <div className="col-lg-4 col-md-6 my-4" key={idx}>
                <FadeUp delay={idx * 0.1}>
                <div
                  className="media-card mx-2 h-100"
                  style={{
                    borderRadius: "12px",
                    overflow: 'hidden',
                    background: 'white',
                    transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                    cursor: 'pointer',
                    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-12px) scale(1.02)';
                    e.currentTarget.style.boxShadow = '0 20px 40px rgba(30, 60, 114, 0.25)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0) scale(1)';
                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.1)';
                  }}
                >
                  <div style={{
                    position: 'relative',
                    overflow: 'hidden',
                    borderRadius: "12px"
                  }}>
                    <img
                      src={img}
                      alt="Flag Day Media"
                      className="school-image"
                      width="100%"
                      height="280px"
                      style={{ 
                        borderRadius: "12px",
                        objectFit: "cover",
                        transition: 'transform 0.5s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'scale(1.1)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'scale(1)';
                      }}
                    />
                    <div style={{
                      position: 'absolute',
                      bottom: 0,
                      left: 0,
                      right: 0,
                      background: 'linear-gradient(to top, rgba(30, 60, 114, 0.9), transparent)',
                      padding: '20px 15px 15px',
                      color: 'white',
                      fontSize: '0.9rem',
                      fontWeight: '500'
                    }}>
                      <FontAwesomeIcon icon={faCamera} className="me-2" />
                      Media Photo {idx + 1}
                    </div>
                  </div>
                </div>
                </FadeUp>
              </div>
            ))}
        </div>
      
      </section>
      <h4 style={{  
          color:'#1e3c72',
          fontWeight: '600',
          marginBottom: '20px',
          marginTop: '30px',
          padding: '10px 0',
          // borderBottom: '3px solid #1e3c72',
          display: 'block',
          textAlign:'center',
          textDecoration:'underline'
        }}>
          <FontAwesomeIcon icon={faCamera} className="me-2" style={{color: '#16a085'}} />
          Conduct of RIMC Examination
        </h4>
   
          <section className="content py-1">
<div className="row justify-content-center">
          {items2.length > 0 &&
            items2.map((img, idx) => (
              <div className="col-lg-4 col-md-6 my-4" key={idx}>
                <FadeUp delay={idx * 0.1}>
                <div
                  className="media-card mx-2 h-100"
                  style={{
                    borderRadius: "12px",
                    overflow: 'hidden',
                    background: 'white',
                    transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                    cursor: 'pointer',
                    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-12px) scale(1.02)';
                    e.currentTarget.style.boxShadow = '0 20px 40px rgba(30, 60, 114, 0.25)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0) scale(1)';
                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.1)';
                  }}
                >
                  <div style={{
                    position: 'relative',
                    overflow: 'hidden',
                    borderRadius: "12px"
                  }}>
                    <img
                      src={img}
                      alt="RIMC Examination Media"
                      className="school-image"
                      width="100%"
                      height="280px"
                      style={{ 
                        borderRadius: "12px",
                        objectFit: "cover",
                        transition: 'transform 0.5s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'scale(1.1)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'scale(1)';
                      }}
                    />
                    <div style={{
                      position: 'absolute',
                      bottom: 0,
                      left: 0,
                      right: 0,
                      background: 'linear-gradient(to top, rgba(30, 60, 114, 0.9), transparent)',
                      padding: '20px 15px 15px',
                      color: 'white',
                      fontSize: '0.9rem',
                      fontWeight: '500'
                    }}>
                      <FontAwesomeIcon icon={faCamera} className="me-2" />
                      RIMC Photo {idx + 1}
                    </div>
                  </div>
                </div>
                </FadeUp>
              </div>
            ))}
        </div>
      
      </section>
        </div>
        </>
    );
};

export default Media;
